export class AppData {
    constructor(accountToken, name, website, email, phoneNumber) {
        this.accountToken = accountToken;
        this.profile = {
            name: name,
            website: website,
            email: email,
            phone_number: phoneNumber,
        };
    }
}
